import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { AplicacionService } from '../shared/aplicacion.service';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { Aplicacion, Iapplication } from '../shared/aplicacion.model';
//ICON
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';


@Component({
  selector: 'app-aplicacion-list',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'aplicacion-list.component.html',
})

export class AplicacionListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[];
  dataSource: GridDataSource; //MatTableDataSource<Iaplicacion>;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(private loaderService: LoaderService, private aplicacionService: AplicacionService,
    private errorService: ErrorService, private notificationService: NotificationService,
    private utilityService: UtilityService, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.msgErrorGet = 'Error al listar las aplicaciones';
    this.displayedColumns = ['Roles', 'AplicacionID', 'Name', 'Path', 'Icono', 'Descripcion', 'Status'];
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
    this.buscarAplicacion("");
  }

  handleRowClick(row: any) {
    this.selectedRowIndex = row.ID;
    this.data.aplicacion = { ID: row.ID, Name: row.Name };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  rolesRowClick(cell: any) {
    this.selectedRowIndex = cell.ID;
    this.data.aplicacion = { ID: cell.ID, Name: cell.Name };
    this.changeEvent({ evento: EVENTO.asignar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarAplicacion(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarAplicacion(this.sectionBarComponent.filtro);
  }

  buscarAplicacion(filtro: string) {
    this.clearMatPaginator();
    this.listarAplicacion(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarAplicacion(filtro: string): void {
    this.loaderService.show();
    this.aplicacionService.listarPorApplication(filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        if (this.errorService.getMessageError(res)) {
          this.dataSource = new GridDataSource(res); //new GridDataSource(res);
          this.showHideMessageGridEmpty(Number(res.length));
          this.pageEvent.length = res.length;
          this.setMatPaginator();
        }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

